import React, { useEffect, useRef, useState } from 'react'
import DatePicker, { registerLocale } from "react-datepicker";
import ru from "date-fns/locale/ru";
import "react-datepicker/dist/react-datepicker.css";
import calendarIcon from './assets/calendar.svg'
import styles from './CustomDatePicker.module.css'

registerLocale('ru', ru);

const ExampleCustomTimeInput = ({date, value, onChange}) => (
    <input
        value={value}
        onChange={e => onChange(e.target.value)}
    />
)


export default function CustomDatePicker({type, trans, tEndDate = new Date(), tSetEndDate, tSetStartDate, tStartDate = new Date(),changePageAction, icon = true, startParams = {}, endParams ={}}) {

    const [startDate, setStartDate] = useState(tStartDate);
    const [endDate, setEndDate] = useState(tEndDate);

    useEffect(() => {
        if (type === 4) {
            setStartDate(new Date(new Date().setFullYear(new Date().getFullYear() - 1)))
        } else if (type === 3) {
            setStartDate(new Date(new Date().setMonth(new Date().getMonth() - 1)))
        } else if (type === 2) {
            setStartDate(new Date(new Date().setDate(new Date().getDate() - 7)))
        } else if (type === 1) {
            setStartDate(new Date(new Date().setDate(new Date().getDate() - 1)))
        }
    }, [type])

    if (!trans) {
        return (
            <div className={styles.container}>
                {icon && <img src={calendarIcon}/>}
                <DatePicker
                    disabled
                    dateFormat="dd.MM.yyyy"
                    selected={startDate}
                    customTimeInput={<ExampleCustomTimeInput/>}
                    {...startParams}
                    locale="ru"
                    calendarStartDay={1}
                />
                <span>-</span>
                <DatePicker
                    disabled
                    dateFormat="dd.MM.yyyy"
                    selected={endDate}
                    customTimeInput={<ExampleCustomTimeInput/>}
                    {...endParams}
                    locale="ru"
                    calendarStartDay={1}
                />
            </div>
        )
    }

    return (
        <div className={styles.container}>
            <img src={calendarIcon}/>
            <DatePicker
                selected={tStartDate}
                onChange={date => {
                    if (changePageAction) {
                      changePageAction(1)
                    }
                    tSetStartDate(date)}
                }
                dateFormat="dd.MM.yyyy"
                placeholderText="        -- -- --"
                customTimeInput={<ExampleCustomTimeInput/>}
                {...startParams}
                locale="ru"
                calendarStartDay={1}
            />
            <span>—</span>
            <DatePicker
                selected={tEndDate}
                onChange={date => {
                    if (changePageAction) {
                      changePageAction(1)
                    }
                    tSetEndDate(date)
                }}
                placeholderText="-- -- --           "
                dateFormat="dd.MM.yyyy"
                customTimeInput={<ExampleCustomTimeInput/>}
                {...endParams}
                locale="ru"
                calendarStartDay={1}
            />
        </div>
    )
}

export function CustomSingleDatePicker({tSetDate, tDate = new Date(), icon = true, ...props}) {

    const [date, setDate] = useState(null);
    const datePickerRef = useRef(null);

    useEffect(() => {
        if (!tDate) return setDate(null);
        setDate(new Date(tDate));
    }, [tDate])

    const handleChangeRaw = (e) => {
        if (!e?.target?.value) return;
        const raw = e.target.value.replace(/\D/g, '');
        if (raw.length === 8) {
            const day = parseInt(raw.substring(0, 2), 10);
            const month = parseInt(raw.substring(2, 4), 10);
            const year = parseInt(raw.substring(4, 8), 10);
            if (day >= 1 && day <= 31 && month >= 1 && month <= 12 && year >= 1900 && year <= 2100) {
                const parsed = new Date(year, month - 1, day);
                if (parsed.getDate() === day && parsed.getMonth() === month - 1 && parsed.getFullYear() === year) {
                    tSetDate ? tSetDate(parsed) : setDate(parsed);
                }
            }
        }
    };

    return (
        <div className={styles.singleContainer}>
            <img src={calendarIcon} onClick={() => datePickerRef.current?.setFocus()} />
            <DatePicker
                ref={datePickerRef}
                placeholderText="-- -- --"
                selected={date}
                onChange={date => tSetDate ? tSetDate(date) : setDate(date)}
                onChangeRaw={handleChangeRaw}
                dateFormat="dd-MM-yyyy"
                customTimeInput={<ExampleCustomTimeInput/>}
                {...props}
                locale="ru"
                calendarStartDay={1}
            />
        </div>
    )

}

